import sample_01 from './sample_01.jpeg';

export const dynamicConstructImageImpressions = {
    sample_01,
};
